import dayjs from "dayjs";
import { UrgentAndCriticalCare } from "../../../hooks/react-query/useInboundUrgentAndCriticalCare";

export const mockInboundUrgentAndCriticalCare: UrgentAndCriticalCare = [
  {
    proNumber: "137844361",
    pickUpDate: new Date("2025-01-24T01:00:00-05:00"),
    serviceDue: new Date(),
    routeOrTrapName: "AZUSA-1",
    startTime: new Date(),
    serviceLevel: "LTL-UC    ",
    careOfDelivery: {
      id: 1,
      name: "FINAFLEX",
      address: "643 Main St",
      city: "New York",
      state: "NY",
      zipCode: "54907",
    },
    consignee: {
      name: "FINAFLEX",
      address: "643 Main St",
      city: "New York",
      state: "NY",
      zipCode: "54907",
    },
    appointmentStartDate: new Date(),
    door: 5,
    driver: {
      id: 60,
      name: "Jane Smith",
      refCode: "8310",
    },
    refTrailerNumber: "ENGC42186",
    tags: [
      {
        id: 3,
        name: "CC",
        description: "Critical care shipment",
        colorHex: "#EA5E5A",
        position: 20,
      },
    ],
    deliveryEta: new Date(),
    status: "CDLK",
    appointmentEndDate: new Date(),
    weight: 1521,
    pallets: 10,
    pieces: 100,
    handlingUnits: 100,
    isPlanned: true,
    futurePlanDates: [],
  },
  {
    proNumber: "137844362",
    pickUpDate: new Date(),
    serviceDue: new Date(),
    routeOrTrapName: "AZUSA-2",
    startTime: new Date(),
    serviceLevel: "LTL-UC    ",
    careOfDelivery: {
      id: 2,
      name: "FOOD SUPPLY LLC",
      address: "789 MARKET ST",
      city: "LOS ANGELES",
      state: "CA",
      zipCode: "90001",
    },
    consignee: {
      name: "FOOD SUPPLY LLC",
      address: "789 MARKET ST",
      city: "LOS ANGELES",
      state: "CA",
      zipCode: "90001",
    },
    appointmentStartDate: new Date(),
    door: 1,
    driver: {
      id: 39,
      name: "John Doe",
      refCode: "1374",
    },
    refTrailerNumber: "ENGC42183",
    tags: [
      {
        id: 3,
        name: "CC",
        description: "Critical care shipment",
        colorHex: "#EA5E5A",
        position: 20,
      },
    ],
    deliveryEta: new Date(),
    status: "ARIV",
    appointmentEndDate: new Date(),
    weight: 1321,
    pallets: 13,
    pieces: 120,
    handlingUnits: 120,
    isPlanned: false,
    futurePlanDates: [parseInt(dayjs().add(1, "day").format("YYYYMMDD"))],
  },
  {
    proNumber: "137844363",
    pickUpDate: new Date(),
    serviceDue: new Date(),
    routeOrTrapName: "AZUSA-3",
    startTime: new Date(),
    serviceLevel: "LTL-UC    ",
    careOfDelivery: {
      id: 3,
      name: "FINAFLEX",
      address: "740 Main St",
      city: "Chicago",
      state: "NY",
      zipCode: "25295",
    },
    consignee: {
      name: "FINAFLEX",
      address: "740 Main St",
      city: "Chicago",
      state: "NY",
      zipCode: "25295",
    },
    appointmentStartDate: new Date(),
    door: 3,
    driver: {
      id: 86,
      name: "Jane Smith",
      refCode: "2425",
    },
    refTrailerNumber: "ENGC42182",
    tags: [
      {
        id: 2,
        name: "UC",
        colorHex: "#FBC02D",
        description: "Urgent care shipment",
        position: 10,
      },
    ],
    deliveryEta: new Date(),
    status: "CDLK",
    appointmentEndDate: new Date(),
    weight: 3211,
    pallets: 5,
    pieces: 142,
    handlingUnits: 142,
    isPlanned: false,
    futurePlanDates: [],
  },
  {
    proNumber: "137844364",
    pickUpDate: new Date(),
    serviceDue: new Date(),
    routeOrTrapName: "CERRITOS-1",
    startTime: new Date(),
    serviceLevel: "LTL-UC    ",
    careOfDelivery: {
      id: 4,
      name: "FINAFLEX",
      address: "989 Main St",
      city: "New York",
      state: "CA",
      zipCode: "50372",
    },
    consignee: {
      name: "FINAFLEX",
      address: "989 Main St",
      city: "New York",
      state: "CA",
      zipCode: "50372",
    },
    appointmentStartDate: new Date(),
    door: 2,
    driver: {
      id: 8,
      name: "Alice Johnson",
      refCode: "3950",
    },
    refTrailerNumber: "ENGC42187",
    tags: [
      {
        id: 2,
        name: "UC",
        description: "Urgent care shipment",
        colorHex: "#FBC02D",
        position: 10,
      },
    ],
    deliveryEta: new Date(),
    status: "ARIV",
    appointmentEndDate: new Date(),
    weight: 4213,
    pallets: 15,
    pieces: 22,
    handlingUnits: 22,
    isPlanned: false,
    futurePlanDates: [],
  },
  {
    proNumber: "137844361",
    pickUpDate: new Date(),
    serviceDue: new Date(),
    routeOrTrapName: "CERRITOS-1",
    startTime: new Date(),
    serviceLevel: "LTL-UC    ",
    careOfDelivery: {
      id: 4,
      name: "FINAFLEX",
      address: "989 Main St",
      city: "New York",
      state: "CA",
      zipCode: "50372",
    },
    consignee: {
      name: "FINAFLEX",
      address: "989 Main St",
      city: "New York",
      state: "CA",
      zipCode: "50372",
    },
    appointmentStartDate: new Date(),
    door: 2,
    driver: {
      id: 8,
      name: "Alice Johnson",
      refCode: "3950",
    },
    refTrailerNumber: "ENGC42187",
    tags: [
      {
        id: 2,
        name: "UC",
        description: "Urgent care shipment",
        colorHex: "#FBC02D",
        position: 10,
      },
    ],
    deliveryEta: new Date(),
    status: "ARIV",
    appointmentEndDate: new Date(),
    weight: 4213,
    pallets: 15,
    pieces: 22,
    handlingUnits: 22,
    isPlanned: false,
    futurePlanDates: [],
  },
  {
    proNumber: "P9376447",
    isPlanned: false,
    futurePlanDates: [],
    pickUpDate: new Date(),
    serviceDue: new Date(),
    routeOrTrapName: "",
    pieces: 17,
    handlingUnits: 17,
    pallets: 1,
    weight: 550,
    startTime: null,
    door: null,
    driver: {
      id: 8,
      name: "Alice Johnson",
      refCode: "3950",
    },
    refTrailerNumber: null,
    deliveryEta: null,
    status: "USGN",
    tags: [
      {
        id: 81,
        name: "VC",
        description: "Vendor Compliance",
        colorHex: "#AA7EA0",
        position: 40,
      },
      {
        id: 6,
        name: "LG",
        description: "Liftgate",
        colorHex: "#679CB2",
        position: 50,
      },
      {
        id: 2,
        name: "UC",
        description: "Urgent care shipment",
        colorHex: "#FBC02D",
        position: 20,
      },
    ],
    appointmentStartDate: null,
    appointmentEndDate: null,
    careOfDelivery: {
      id: 30603761,
      name: "SUN MEXICO LOGISTICS",
      address: "720 E San Ysidro Blvd",
      city: "San Diego",
      state: "CA",
      zipCode: "92173",
    },
    consignee: {
      name: "SAN YSIDRO PORT",
      address: "720 E San Ysidro Blvd",
      city: "San Diego",
      state: "CA",
      zipCode: "92173",
    },
    delivery: {
      name: "SAN YSIDRO PORT",
      address: "720 E San Ysidro Blvd",
      city: "San Diego",
      state: "CA",
      zipCode: "92173",
    },
    serviceLevel: "MXUS-LTL",
  },
  {
    proNumber: "157852328",
    isPlanned: false,
    futurePlanDates: [],
    pickUpDate: new Date(),
    serviceDue: new Date(),
    routeOrTrapName: "",
    pieces: 0,
    handlingUnits: 0,
    pallets: 1,
    weight: 600,
    startTime: null,
    door: null,
    driver: {
      id: 8,
      name: "Alice Johnson",
      refCode: "3950",
    },
    refTrailerNumber: "DYLT205022",
    deliveryEta: null,
    status: "ENRT",
    tags: [
      {
        id: 9,
        name: "DTCL",
        description: "Delivery to Connecting Line",
        colorHex: "#5E9FE0",
        position: 190,
      },
      {
        id: 2,
        name: "UC",
        description: "Urgent care shipment",
        colorHex: "#FBC02D",
        position: 20,
      },
    ],
    appointmentStartDate: null,
    appointmentEndDate: null,
    consignee: {
      name: "SEVEN TECHNOLOGIES",
      address: "333 ADAMS ST",
      city: "BEDFORD HILLS",
      state: "NY",
      zipCode: "10507",
    },
    delivery: {
      name: "PME-PMLI-EWR DOCK",
      address: "204-248 NORTH AVENUE EAST",
      city: "ELIZABETH",
      state: "NJ",
      zipCode: "07201",
    },
    serviceLevel: "MXUS-LTL",
    careOfDelivery: null,
  },
];
